var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import { ReactPortalProvider } from '@shared-ui/portal-context';
import { TripSaveItem, ValidatedInputsState, Source } from '@shared-ui/trips-save-item';
import { buildStateProvider } from '@shared-ui/provided-state-context';
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
export var TripSaveItemWrapper = function (_a) {
  var _b;
  var saveItem = _a.saveItem,
    heartLayoutPosition = _a.heartLayoutPosition;
  var _c = __read(React.useState({}), 2),
    reactPortalContext = _c[0],
    setReactPortalContext = _c[1];
  React.useEffect(function () {
    setReactPortalContext({
      htmlElement: document.body
    });
  }, []);
  switch ((_b = saveItem.attributes) === null || _b === void 0 ? void 0 : _b.__typename) {
    case 'TripsSaveActivityAttributes':
      {
        var saveItemData = saveItem;
        return React.createElement(ReactPortalProvider, {
          reactPortalContext: reactPortalContext
        }, React.createElement(ValidatedInputsStateProvider, null, React.createElement(TripSaveItem, {
          data: saveItemData,
          source: Source.ACTIVITY_SEARCH,
          heartLayoutPosition: heartLayoutPosition || undefined
        })));
      }
    default:
      return null;
  }
};